import { EnumAppointmentReminderStatus } from "@bbj-types/action/appointmentReminder";
import { Box, Popover, Stack, Typography } from "@mui/material";
import { type ReactNode, useState } from "react";
import { ReminderStatusIcon } from "./icon";
import { reminderStatusMapping } from "./mapping";

interface IReminderStatusProps {
  status?: EnumAppointmentReminderStatus;
  children: ReactNode;
}

/**
 * Displays the appointment reminder status of an action: a bell icon depending on the status,
 * followed by the date. The ticket asks for the message to open on a click on the date, so only
 * the date is clickable (and underlined on hover).
 */
export const ReminderStatus = ({ status, children }: IReminderStatusProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const reminderStatus = status ?? EnumAppointmentReminderStatus.NOT_SCHEDULED;

  return (
    <>
      <Stack direction="row" alignItems="center" sx={{ gap: 0.5 }}>
        <ReminderStatusIcon status={reminderStatus} />
        <Box
          onClick={(event) => setAnchorEl(event.currentTarget)}
          sx={{ cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
        >
          {children}
        </Box>
      </Stack>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Typography variant="body2" sx={{ p: 2, maxWidth: 300 }}>
          {reminderStatusMapping[reminderStatus].message}
        </Typography>
      </Popover>
    </>
  );
};

export * from "./icon";
export * from "./info";
export * from "./mapping";
